import styled from "styled-components";

export const BackButtonWrapper = styled.div`
  padding-bottom: 2rem;
`;
